import React from 'react';
import { useNavigate } from 'react-router-dom';
import useThumbnailUrl from '../../hooks/useThumbnailUrl';

const DigitalCard = ({ item }) => {
  const imageUrl = useThumbnailUrl(item.thumbnail_info, 296);
  const navigate = useNavigate();
  const handleClickCard = (id) => {
    navigate(`/product-digital-detail/${id}`);
  };

  return (
    <div className={'product-card video-card type-digital-card'}>
      <figure
        className='product-card-img-group cursor-pointer'
        onClick={() => {
          handleClickCard(item.id);
        }}
      >
        <img
          fetchpriority='high'
          src={imageUrl || '/images/img_no_img.png'}
          alt='video thumbnail'
          className={'product-card-img'}
          width='293.5'
          height='293.5'
          onError={(e) => {
            e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
            e.target.src = '/images/img_no_img.png';
          }}
          decoding={'async'}
        />
      </figure>
      <div className='product-card-txt-group'>
        <h3
          className={'product-card-title cursor-pointer'}
          onClick={() => {
            handleClickCard(item.id);
          }}
        >
          {item.title}
        </h3>
      </div>
    </div>
  );
};

export default DigitalCard;
